import { type ReactNode } from 'react';

interface MainContentProps {
  children: ReactNode;
}

/**
 * MainContent - Main Content Area
 *
 * Scrollable content area with consistent padding.
 * Modern SaaS design: clean, minimal, proper spacing.
 */
export function MainContent({ children }: MainContentProps) {
  return (
    <main className="flex-1 bg-white min-h-0 overflow-hidden">
      <div className="h-full p-6 overflow-auto">{children}</div>
    </main>
  );
}
